export const SESSION_COOKIE_NAME = 'session'
export const SESSION_CHECK_INTERVAL = 10 * 60 * 1000 // 10 min
export const TOKEN_REFRESH_INTERVAL = 5 * 60 * 1000 // 5 min
export const SESSION_COOKIE_MAX_AGE = 20 * 60 * 1000 // 20 min
export const CLOCK_SKEW_TOLERANCE = 60 // 60 seconds margin for clock skew

export type Session = {
  id: string
  accessToken: string
}
